import React, {lazy, Suspense} from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import {Link, useLocation} from 'react-router-dom';
import {adminRoutes} from 'App/AppRouter/routes';
import {
    IngestConfigFilters,
    InputChangeType,
    SelectChangeType,
    IngestSelectList,
} from './IngestConfigTypes';
import IngestConfigsSelect from './IngestConfigsToolbarSelect';
import './IngestConfigsToolbar.scss';

const ContentPartners = lazy(() => import('@pluto/content-partners'));

interface Props {
    handleNameChange: InputChangeType;
    handleStatusChange: SelectChangeType;
    handlePartnersChange: InputChangeType;
    handleIngestTypeChange: SelectChangeType;
    handleLabPartnerChange: SelectChangeType;
    name: string;
    filters: IngestConfigFilters;
    types: IngestSelectList;
    statuses: IngestSelectList;
    labPartners: IngestSelectList;
}

export default function IngestConfigsToolbar(props: Props) {
    const {
        handleNameChange,
        handleStatusChange,
        handlePartnersChange,
        handleIngestTypeChange,
        handleLabPartnerChange,
        name,
        filters,
        types,
        statuses,
        labPartners,
    } = props;
    const {search} = useLocation();
    const url = `${adminRoutes.newIngestFeed}${search}`;
    const searchAdornment = (
        <InputAdornment position="start">
            <SearchIcon />
        </InputAdornment>
    );

    return (
        <Box className="toolbar">
            <Box className="toolbar-actions">
                <FormControl className="toolbar-actions__input-container">
                    <Input
                        id="ingest-name"
                        autoComplete="off"
                        value={name}
                        placeholder="Filter by config name..."
                        onChange={handleNameChange}
                        startAdornment={searchAdornment}
                    />
                </FormControl>
                <Suspense fallback={<CircularProgress />}>
                    <ContentPartners
                        value={filters.contentPartnerId}
                        onChange={handlePartnersChange as any}
                        placeholder="Content partner"
                    />
                </Suspense>
                <IngestConfigsSelect
                    value={filters.ingestType}
                    handleChange={handleIngestTypeChange}
                    placeholder="Ingest type"
                    values={types}
                />
                <IngestConfigsSelect
                    value={filters.labPartner}
                    handleChange={handleLabPartnerChange}
                    placeholder="Lab partner"
                    values={labPartners}
                />
                <IngestConfigsSelect
                    value={filters.status}
                    handleChange={handleStatusChange}
                    placeholder="Status"
                    values={statuses}
                />
            </Box>
            <Link className="toolbar__button-link" to={url}>
                <Button className="toolbar__button" variant="outlined" color="primary">
                    NEW INGEST CONFIG
                </Button>
            </Link>
        </Box>
    );
}
